import axios, { AxiosRequestConfig } from 'axios'
export const onThen = (response) => response;
export const onCatch = ({ response }) => response;
export const fetcher = (url, params) => axios.get(url, params).then(res => res.data)
export const fetcherPost = (url, params) => axios.post(url, params).then(res => res.data)
